import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { ArticleCommentsTrigger } from "scmp-app/components/article/article-comments-trigger";
import { ArticleCommentsButton } from "scmp-app/components/article/article-comments-trigger/button";
import { CountMessage } from "scmp-app/components/article/article-comments-trigger/button/styles";
import { responsiveStyles } from "scmp-app/components/header/features/styles";
import type { ResponsiveStyledProps } from "scmp-app/components/header/features/types";

export const Container = styled.div<ResponsiveStyledProps>`
  ${responsiveStyles}
`;

const commentsTriggerStyles = css`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;

  inline-size: 36px;
  block-size: 36px;
  margin-inline-end: 0;

  ${CountMessage} {
    inset-block-start: 0;
  }
`;

export const StyledArticleCommentsTrigger = styled(ArticleCommentsTrigger)`
  ${commentsTriggerStyles}
`;

export const StyledArticleCommentsTriggerButton = styled(ArticleCommentsButton)`
  ${commentsTriggerStyles}
`;
